import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Creators as studentSimulatedActions } from '../../../domain/useCases/simulatorUseCase/getStudentSimulated';
import AdministratorView from './AdministratorView';
import { Creators as logOutActions } from '../../../domain/useCases/login/signOutUseCase';
import GoogleAnalytics from '@/presentation/hooks/useGoogleAnalytics';

const AdministratorViewController = () => {
  const dispatch = useDispatch();
  const [error, setError] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [modalNotEnrolled, setModalNotEnrolled] = useState(false);

  const { isLoading, error: errorSimulator } = useSelector(
    (state: any) => state.studentSimulated
  );

  useEffect(() => {
    if (errorSimulator === 'error-02') {
      setModalNotEnrolled(true);
    }
  }, [errorSimulator]);

  const handleInputChange = (code: string) => {
    const TrimmedCode = code.trim();
    if (TrimmedCode.length < 7 || TrimmedCode.length > 9) {
      setError(true);
      setDisabled(true);
    } else {
      setError(false);
      setDisabled(false);
    }
  };

  const handleLogOut = () => {
    dispatch(logOutActions.signOut());
  };

  const handleActiveSimulate = (code: string) => {
    GoogleAnalytics.writeLog('portal-simulation-simulate', 'simulation');
    dispatch(studentSimulatedActions.getStudentById(code));
  };

  return (
    <AdministratorView
      handleActiveSimulate={handleActiveSimulate}
      error={error}
      handleInputChange={handleInputChange}
      disabled={disabled}
      isLoading={isLoading}
      handleLogOut={handleLogOut}
      modalNotEnrolled={modalNotEnrolled}
      setModalNotEnrolled={setModalNotEnrolled}
    />
  );
};

export default AdministratorViewController;
